module.exports = __webpack_public_path__ + "img/Checkbox selected Icon - white.5012bccd.svg";